/* ZO•ON motion + card details (Sept 2026) – smooth, calm transitions across the site.
   Styles live at the end of assets/zoon-premium.css. Everything degrades to the normal site
   if JavaScript fails, and nothing moves for visitors who ask their phone for reduced motion. */
(function () {
  'use strict';
  var Z = window.ZOON || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 800) && r.bottom > 0;
  }

  /* 1. Sections and product cards fade up as they scroll into view */
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
  }
  function reveal(el, delay) {
    if (!io || el.getAttribute('data-zoon-reveal')) return;
    el.setAttribute('data-zoon-reveal', '1');
    if (inView(el)) return;               /* already on screen: leave it alone, no flicker */
    if (delay) el.style.transitionDelay = delay + 'ms';
    el.classList.add('zoon-reveal');
    io.observe(el);
  }
  function revealAll() {
    if (!io) return;
    var main = document.getElementById('MainContent') || document.body;
    /* Whole sections (homepage blocks, product-page blocks, footer trust row) */
    main.querySelectorAll(':scope > .shopify-section, :scope > section, .zoon-rv').forEach(function (s, i) {
      if (i === 0 && s.querySelector('.hero__wrapper')) return; /* hero has its own intro */
      if (s.querySelector('.collection__product-grid')) return;  /* grid cards animate one by one */
      reveal(s);
    });
    document.querySelectorAll('.section__logo-bar, #shopify-section-site-footer').forEach(function (s) { reveal(s); });
    /* Collection / search grids: cards one by one, gently staggered across each row */
    document.querySelectorAll('.collection__product-grid').forEach(function (grid) {
      var n = 0;
      grid.querySelectorAll(':scope > .product-item').forEach(function (li) {
        if (li.getAttribute('data-zoon-reveal')) return;
        if (li.offsetParent === null) return; /* not shown yet (load more) – picked up later */
        reveal(li, (n++ % 4) * 70);
      });
    });
  }

  /* 2. Product photos fade in when they finish loading instead of popping in */
  function fadeImages(scope) {
    if (reduce) return;
    (scope || document).querySelectorAll('.product-item__image img:not(.zoon-hover-img), .zoon-rv__img img').forEach(function (img) {
      if (img.getAttribute('data-zoon-img')) return;
      img.setAttribute('data-zoon-img', '1');
      if (img.complete && img.naturalWidth > 0) return;
      img.classList.add('zoon-img-fade');
      var done = function () { img.classList.add('is-loaded'); };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
      setTimeout(done, 4000); /* never leave a photo hidden */
    });
  }

  /* 3. Soft fade-out when leaving for another page on the site */
  function pageLeave() {
    if (reduce) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target && a.target !== '_self' || a.hasAttribute('download')) return;
      var toggler = a.closest('[data-change-class]');
      if (toggler && (toggler.getAttribute('data-change-class') || '').indexOf('preventDefault') !== -1) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      e.preventDefault();
      document.documentElement.classList.add('zoon-leaving');
      setTimeout(function () { location.href = url.href; }, 220);
    });
    window.addEventListener('pageshow', function () { document.documentElement.classList.remove('zoon-leaving'); });
  }

  /* 4. Sale cards show the real discount, e.g. "-20%" (like mettasport.is) */
  function salePercent(scope) {
    (scope || document).querySelectorAll('.product-item').forEach(function (li) {
      var badge = li.querySelector('.product-item__image .sale-badge');
      if (!badge || badge.getAttribute('data-zoon-pct')) return;
      var priceEl = li.querySelector('.product-item__price');
      if (!priceEl) return;
      var nums = (priceEl.textContent.match(/\d[\d.,\s]*\d|\d/g) || []).map(function (s) {
        return parseInt(s.replace(/[^\d]/g, ''), 10);
      }).filter(function (n) { return n > 0; });
      if (nums.length < 2) return;
      var hi = Math.max.apply(null, nums), lo = Math.min.apply(null, nums);
      var pct = Math.round((hi - lo) / hi * 100);
      if (pct < 1 || pct > 90) return;
      badge.setAttribute('data-zoon-pct', pct);
      badge.textContent = '-' + pct + '%';
    });
  }

  /* 5. Long colour rows: show 4, then "+3" (like mettasport.is) */
  function swatchMore(scope) {
    (scope || document).querySelectorAll('.product-item__info .swatch-container').forEach(function (box) {
      if (box.getAttribute('data-zoon-more')) return;
      box.setAttribute('data-zoon-more', '1');
      var sw = box.querySelectorAll('.color-swatch');
      var max = 4;
      if (sw.length <= max + 1) return;
      for (var i = max; i < sw.length; i++) sw[i].classList.add('zoon-swatch-hidden');
      var more = document.createElement('a');
      var extra = sw.length - max;
      var link = box.closest('.product-item') && box.closest('.product-item').querySelector('.product-item__image');
      more.className = 'zoon-swatch-more';
      more.href = link ? link.getAttribute('href') : '#';
      more.textContent = '+' + extra;
      more.title = Z.en ? extra + ' more colours' : extra + ' litir í viðbót';
      box.appendChild(more);
    });
  }

  /* 6. Colour swatches on product cards: hover (computers) previews the colour, click/tap picks it –
        the card photo changes to that colour and the card links straight to that colour on the product page */
  var cardOrig = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function cardParts(sw) {
    var li = sw.closest('.product-item');
    if (!li) return null;
    var img = li.querySelector('.product-item__image img:not(.zoon-hover-img)');
    return { li: li, img: img, links: li.querySelectorAll('a.product-item__image, .product-item__title a, a.zoon-swatch-more') };
  }
  function remember(p) {
    if (!cardOrig || cardOrig.has(p.li)) return;
    cardOrig.set(p.li, {
      src: p.img ? (p.img.getAttribute('data-preload') || p.img.currentSrc || p.img.src) : '',
      hrefs: Array.prototype.map.call(p.links, function (a) { return a.getAttribute('href'); })
    });
  }
  function showImg(p, src, src2) {
    if (!p.img || !src) return;
    if (p.img.getAttribute('data-zc-cur') === src) return;
    p.img.setAttribute('data-zc-cur', src);
    var pre = new Image();
    pre.onload = function () {
      if (p.img.getAttribute('data-zc-cur') !== src) return;
      p.img.removeAttribute('data-preload');
      p.img.removeAttribute('srcset');
      p.img.src = src;
      if (src2) p.img.setAttribute('srcset', src + ' 630w, ' + src2 + ' 1260w');
      p.img.classList.add('is-loaded');
    };
    pre.src = src;
  }
  function withVariant(href, id) {
    if (!href || !id) return href;
    try { var u = new URL(href, location.href); u.searchParams.set('variant', id); return u.pathname + u.search + u.hash; }
    catch (e) { return href; }
  }
  function pickSwatch(sw, commit) {
    var p = cardParts(sw);
    if (!p) return;
    remember(p);
    showImg(p, sw.getAttribute('data-zc-img'), sw.getAttribute('data-zc-img2'));
    if (!commit) return;
    p.li.classList.add('zc-picked');
    var box = sw.closest('.swatch-container');
    p.li.querySelectorAll('.color-swatch[role=button]').forEach(function (s) {
      var on = s.getAttribute('data-color-name') === sw.getAttribute('data-color-name');
      s.classList.toggle('checked', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var id = sw.getAttribute('data-zc-variant');
    var orig = cardOrig && cardOrig.get(p.li);
    Array.prototype.forEach.call(p.links, function (a, i) {
      var base = orig && orig.hrefs[i] ? orig.hrefs[i] : a.getAttribute('href');
      a.setAttribute('href', withVariant(base, id));
    });
    if (box) box.setAttribute('data-zc-picked', sw.getAttribute('data-color-name'));
  }
  function restoreCard(li) {
    var picked = li.querySelector('.swatch-container[data-zc-picked]');
    var p = { li: li, img: li.querySelector('.product-item__image img:not(.zoon-hover-img)') };
    if (picked) {
      var name = picked.getAttribute('data-zc-picked');
      picked.querySelectorAll('.color-swatch').forEach(function (s) {
        if (s.getAttribute('data-color-name') === name) showImg(p, s.getAttribute('data-zc-img'), s.getAttribute('data-zc-img2'));
      });
      return;
    }
    var orig = cardOrig && cardOrig.get(li);
    if (orig && orig.src) showImg(p, orig.src);
  }
  function swatchEvents() {
    document.addEventListener('click', function (e) {
      var sw = e.target.closest ? e.target.closest('.product-item .color-swatch[role=button]') : null;
      if (!sw) return;
      e.preventDefault();
      e.stopPropagation();
      pickSwatch(sw, true);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest ? e.target.closest('.product-item .color-swatch[role=button]') : null;
      if (!sw) return;
      e.preventDefault();
      pickSwatch(sw, true);
    });
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseover', function (e) {
        var sw = e.target.closest ? e.target.closest('.product-item .color-swatch[role=button]') : null;
        if (sw) pickSwatch(sw, false);
      });
      document.addEventListener('mouseout', function (e) {
        var box = e.target.closest ? e.target.closest('.product-item .swatch-container') : null;
        if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
        var li = box.closest('.product-item');
        if (li) restoreCard(li);
      });
    }
  }

  /* 7. "Sjá meira" (load more) only shows when there really are more products waiting.
        The theme always prints the button and only hid it after a pointless click. */
  function syncLoadMore() {
    document.querySelectorAll('.collection__product-grid').forEach(function (grid) {
      var wrap = grid.parentNode && grid.parentNode.querySelector('.paginater');
      if (!wrap) return;
      var left = grid.querySelectorAll(':scope > .product-item.visually-hidden:not(.zf-out)').length;
      wrap.style.display = left ? '' : 'none';
    });
  }

  /* 8. Sharp photos without waiting: the theme shows a tiny 50px placeholder and only swaps in the real photo
        (data-preload) after the whole page has loaded – on big collections that left cards blurry. Here each photo
        is swapped in as soon as it comes near the screen. */
  var sharpIO = null;
  function sharpen(img) {
    var s = img.getAttribute('data-preload');
    if (!s || img.getAttribute('data-zs') === s) return;
    img.setAttribute('data-zs', s);
    var cur = img.getAttribute('src') || '';
    if (cur === s) return;
    var pre = new Image();
    pre.onload = function () { if (img.getAttribute('data-preload') === s) img.src = s; };
    pre.src = s;
  }
  function sharpenAll() {
    var imgs = document.querySelectorAll('img[data-preload]:not([data-zs-watch])');
    if (!imgs.length) return;
    if (!sharpIO && 'IntersectionObserver' in window) {
      sharpIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { sharpen(e.target); sharpIO.unobserve(e.target); } });
      }, { rootMargin: '400px 0px' });
    }
    imgs.forEach(function (img) {
      img.setAttribute('data-zs-watch', '1');
      if (sharpIO) sharpIO.observe(img); else sharpen(img);
    });
  }

  /* 9. Quick view ("Skoða"): the theme's own close button breaks on products with a single photo (its slider
        crashes before the close button is wired up), so windows piled up and the next product opened behind the
        old one. Here: ×, a click on the dark background or Esc always closes, and opening one closes any other. */
  function closeQuickViews(except) {
    document.querySelectorAll('.collection__quick-view.show').forEach(function (m) { if (m !== except) m.classList.remove('show'); });
  }
  function quickViewEvents() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var opener = e.target.closest('[data-quick-view]');
      if (opener) { closeQuickViews(); return; }
      var x = e.target.closest('.collection__quick-view .popup--close');
      if (x) { e.preventDefault(); closeQuickViews(); return; }
      if (e.target.classList && e.target.classList.contains('collection__quick-view')) closeQuickViews();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickViews(); });
  }

  function cardsPass(scope) {
    try { syncLoadMore(); } catch (e) {}
    try { sharpenAll(); } catch (e) {}
    try { salePercent(scope); } catch (e) {}
    try { swatchMore(scope); } catch (e) {}
    try { fadeImages(scope); } catch (e) {}
  }

  ready(function () {
    document.documentElement.classList.add('zoon-motion');
    cardsPass();
    try { revealAll(); } catch (e) {}
    try { pageLeave(); } catch (e) {}
    try { swatchEvents(); } catch (e) {}
    try { quickViewEvents(); } catch (e) {}
    window.addEventListener('load', function () { try { syncLoadMore(); } catch (e) {} });
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { cardsPass(); try { revealAll(); } catch (e) {} }, 320);
      }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  });
})();